<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-4 lbl">
          <label>Numéro de dossier :</label>
        </div>
        <div class="col txt">
          <p v-if="!this.dossier.numeroCardexAfficher"> ... </p>
          <p v-else> {{ this.dossier.numeroCardexAfficher }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Catégorie :</label>
        </div>
        <div class="col txt">
          <p v-if="!this.dossier.categorieAfficher"> ... </p>
          <p v-else> {{ this.dossier.categorieAfficher }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Type de jeux :</label>
        </div>
        <div class="col">
          <Dropdown v-model="this.typeJeu"
                    :options="typeJeuLibelles" optionValue="valeur"
                    optionLabel="texte" scrollHeight="205px" :showClear="true"/>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Jeux choisis :</label>
    </div>
    <div class="col">
      <vue-list-picker title-left="Jeux disponibles" title-right="Jeux choisis" min-height="120px"
                       :left-items="leftJeuxDisponibles" :right-items="rightJeuxChoisis"/>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import {mapGetters} from 'vuex';
import {VueListPicker} from 'vue-list-picker';

export default {
  name: 'ModifierChampsJeux',
  props: ['isModifier'],
  components: {
    VueListPicker
  },
  data() {
    return {
      leftJeuxDisponibles: [],
      rightJeuxChoisis: [],
      typeJeuLibelles: [],
      typeJeu: null,
      jeuxLibelles: [],
      jeuxDisponibles: [],
      listJeux: [],
    };
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      dossier: 'dossier/dossier',
      listeJeux: 'jeux/listeJeux',
    })
  },
  beforeMount() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store
        .dispatch('jeux/rechercherJeuxDefaut48HeuresAction')
        .then((res) => {
          this.typeJeuLibelles = res.data.entiteDecision.typeJeu.libelles;
          this.setListeJeux();
        });
  },
  methods: {
    getJeuxLocal() {
      this.listJeux = [];
      for (let i = 0; i < this.rightJeuxChoisis.length; i++) {
        this.listJeux.push({
          jeu: this.rightJeuxChoisis[i].key,
          jeuxAfficher: this.rightJeuxChoisis[i].content,
          cleDossier: this.dossier.cle,
          siteDossier: this.dossier.site,
        });
      }
      return this.listJeux;
    },
    getAncienJeuxLocal() {
      if (this.getNewJeuxLocal().length == 0 && this.getJeuxASupprimer().length == 0) {
        return this.listJeux;
      } else {
        let liste = [];
        let listAncienJeux = [];
        Object.values(this.listeJeux).forEach(sc => {
          listAncienJeux.push(sc)
        });
        for (let i = 0; i < listAncienJeux.length; i++) {
          liste.push({
            jeu: listAncienJeux[i].jeu,
            jeuxAfficher: listAncienJeux[i].jeuAfficher,
            cleDossier: this.dossier.cle,
            siteDossier: this.dossier.site,
          });
        }
        return liste;
      }
    },
    getNewJeuxLocal() {
      let newJeuxLocal = [];
      let newJeuxLocals = [];
      if (this.rightJeuxChoisis.length == 0)
        return newJeuxLocal;
      Object.values(this.listeJeux).forEach(je => {
        newJeuxLocal.push(je)
      });
      newJeuxLocal = this.rightJeuxChoisis.filter(ar =>
          !newJeuxLocal.find(rm => (rm.jeu === ar.key))
      );
      for (let i = 0; i < newJeuxLocal.length; i++) {
        newJeuxLocals.push({
          jeu: newJeuxLocal[i].key,
          jeuxAfficher: newJeuxLocal[i].content,
          cleDossier: this.dossier.cle,
          siteDossier: this.dossier.site,
        });
      }
      return newJeuxLocals;
    },
    getJeuxASupprimer() {
      let jeuxASupprimer = [];
      Object.values(this.listeJeux).forEach(je => {
        jeuxASupprimer.push(je)
      });
      jeuxASupprimer = jeuxASupprimer
          .filter(ar => !this.rightJeuxChoisis.find(rm => (rm.key === ar.jeu)))
      return jeuxASupprimer;
    },
    setListeJeux() {
      let jeuxChoisis = [];
      if (this.isModifier) {
        Object.values(this.listeJeux).forEach(je => {
          jeuxChoisis.push(je)
        });
        for (let i = 0; i < jeuxChoisis.length; i++) {
          this.rightJeuxChoisis.push({
            key: jeuxChoisis[i].jeu,
            content: jeuxChoisis[i].jeuxAfficher
          });
        }
      }
    },
    setleftJeuxList() {
      this.leftJeuxDisponibles = [];
      if (this.isModifier) {
        this.jeuxDisponibles = this.jeuxDisponibles
            .filter(je => !this.rightJeuxChoisis
                .find(rm => (rm.key === je.valeur)))
      }
      for (let i = 0; i < this.jeuxDisponibles.length; i++) {
        this.leftJeuxDisponibles.push({
          key: this.jeuxDisponibles[i].valeur,
          content: this.jeuxDisponibles[i].texte
        });
      }
    }
  },
  watch: {
    typeJeu: function (val) {
      if (val !== null && val !== undefined && this.entite !== null) {
        this.$store.dispatch('dossier/onChangeEntityAction', {
          libelleChange: 'Jeux',
          nouvelleValeur: [val, this.dossier.entite]
        }).then((res) => {
          this.jeuxLibelles = res.data;
          this.jeuxDisponibles = res.data;
          this.setleftJeuxList();
        });
      } else {
        this.jeux = null;
        this.jeuxLibelles = [];
      }
    },
  }
}
</script>